"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vue = _interopRequireDefault(require("vue"));
var _store = _interopRequireDefault(require("./store"));
_vue.default.config.errorHandler = function (err, vm, info) {
  _store.default.commit('ADD_LOGS', {
    type: 'error',
    message: err.message,
    stack: err.stack,
    info
  });
  if (process.env.NODE_ENV === 'development') {
    throw err;
  }
};